export default {
  methods: {
    $deleteTimestamps(entity) {
      delete entity.createdAt;
      delete entity.updatedAt;
    },
  },
};
